import { render } from "./PaylasSvg.vue?vue&type=template&id=84d4d75e"
import script from "./PaylasSvg.vue?vue&type=script&lang=js"
export * from "./PaylasSvg.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__